import {useMutation} from '@tanstack/react-query';
import onboardingUpdaters from '@/api/updaters/content-studio/onboarding';

export function useUpdateConsent() {
  return useMutation({
    mutationFn: onboardingUpdaters.updateConsent,
  });
}

export default useUpdateConsent;
